import classNames from "classnames";
import React, { useContext } from "react";
import { ComponentWidth } from "../../model/landing-page";
import { Col, Row } from "../Grid";
import StyledContent, {
  SanityStyledContent
} from "../StyledContent/StyledContent";
import styles from "./Ratio.module.scss";

type Ratios = "1-1" | "3-1" | "1-3";

type Side = "left" | "right";

const RatioContext = React.createContext<Side>("left");

export const useSide = (): Side => {
  return useContext(RatioContext);
};

type Layout = "landing" | "default";

interface SanityRatio {
  ratio: Ratios;
  leftContent: SanityStyledContent;
  rightContent: SanityStyledContent;
  componentWidth: ComponentWidth;
  layout: Layout;
}

export interface RatioProps {
  node: SanityRatio;
  className?: string;
}

const calculateCol = (index: number, ratio: Ratios, layout: Layout) => {
  switch (ratio) {
    case "1-3":
      return {
        md: index === 0 ? 3 : 9,
        sm: index === 0 ? 5 : 7,
        xs: 12,
        className: index === 0 ? styles.hide : undefined
      };
    case "3-1":
      return {
        md: index === 0 ? 9 : 3,
        sm: index === 0 ? 7 : 5,
        xs: 12,
        className: index === 0 ? undefined : styles.hide
      };
    default:
      if (layout !== "landing") {
        return {
          xs: 12,
          sm: 6,
          className: index === 0 ? styles.hide : undefined
        };
      }
      return {
        md: 6,
        className: index === 0 ? styles.hide : undefined
      };
  }
};

export const Ratio = ({
  node: {
    leftContent,
    rightContent,
    ratio,
    componentWidth = "full",
    layout = "landing"
  },
  className
}: RatioProps) => {
  // We hide the smaller column on mobile if layout === "landing".
  return (
    <Row
      className={classNames(
        styles.root,
        styles[layout],
        className,
        `${componentWidth}Width`
      )}
    >
      <RatioContext.Provider value="left">
        <Col {...calculateCol(0, ratio, layout)}>
          <StyledContent node={leftContent} />
        </Col>
      </RatioContext.Provider>
      <RatioContext.Provider value="right">
        <Col {...calculateCol(1, ratio, layout)}>
          <StyledContent node={rightContent} />
        </Col>
      </RatioContext.Provider>
    </Row>
  );
};

export default Ratio;
